import ImageSlider from "react-image-comparison-slider";
import style from "./renderComparison.module.scss";
import constant from "../../../../constants/constants.json";

export const RenderComparison = ({ leftPhoto, rightPhoto, resetComparison }) => {
  const renderComparison = () => {
    if (!leftPhoto && !rightPhoto) {
      return <div className={style.placeholder_text}>{constant.photos.compareFirstPhoto}</div>;
    }
    if ((leftPhoto && !rightPhoto) || (!leftPhoto && rightPhoto)) {
      return <div className={style.placeholder_text}>{constant.photos.compareAnotherPhoto}</div>;
    }
    return (
      <div className={style.slider_wrapper}>
        <ImageSlider
          image2={leftPhoto.src}
          image1={rightPhoto.src}
          sliderColor="#ffffff"
          sliderLineWidth={2}
          leftLabelText={leftPhoto.label}
          rightLabelText={rightPhoto.label}
        />
      </div>
    );
  };

  return (
    <div className={style.compare_card}>
      {(leftPhoto || rightPhoto) && (
        <button className={style.reset_btn_compare} type="button" aria-label="Reset comparison" title="Reset comparison" onClick={resetComparison}>
          <i className="fa fa-times fa-lg" aria-hidden="true"></i>
        </button>
      )}
      <div style={{ width: "100%", height: 600 }} className="d-flex align-items-center justify-content-center">
        {renderComparison()}
      </div>
    </div>
  );
};
